const us = {
  code: 'us',
  name: 'United States',
  flag: '🇺🇸',
  localTips: [
    'IRS and Social Security impersonation calls are frequent — government agencies do not demand payment by gift card or crypto.',
    'Package delivery and bank fraud texts often use spoofed local numbers.',
  ],
  resources: [
    {
      title: 'ReportFraud.ftc.gov',
      description: 'Report fraud, scams, and bad business practices to the FTC.',
      url: 'https://reportfraud.ftc.gov/',
    },
    {
      title: 'IdentityTheft.gov',
      description: 'Recovery plan if your identity or accounts were compromised.',
      url: 'https://www.identitytheft.gov/',
    },
    {
      title: 'FCC Consumer Complaints',
      description: 'Complaints about unwanted calls and texts.',
      url: 'https://consumercomplaints.fcc.gov/',
    },
  ],
};

export default us;
